var current_product = document.querySelector('#related-product');
var familia = encodeURIComponent(current_product.dataset.familia);
var genero = encodeURIComponent(current_product.dataset.genero);
var tipo = encodeURIComponent(current_product.dataset.tipo);
var handle = current_product.dataset.handle;
// const api_url = `https://filter-x3.globo.io/api/apiFilter?filter_id=1511&shop=cat-mx.myshopify.com&collection=490566713665&sort_by=best-selling&country=MX&event=all&filter%5B18437%5D%5B%5D=${familia}&filter%5B18512%5D%5B%5D=${genero}&page=1&cid=0c78d622-d6c8-4a36-ada2-6e77f50d242c&did=4d4c79fa-8faa-4f8e-9fd6-514b2e144b5a&page_type=collection`;
const api_url =`https://filter-x3.globo.io/api/apiFilter?filter_id=52118&shop=cat-mx.myshopify.com&collection=490566713665&sort_by=best-selling&country=MX&cache=0&filter%5B18437%5D%5B%5D=${familia}&filter%5B18512%5D%5B%5D=${genero}&filter%5B839846%5D%5B%5D=${tipo}&event=all&page=1&cid=f333fce6-0277-4e47-b592-00e51310aed5&did=e602b93e-add8-41ae-b5a6-16ffff45161d&page_type=collection`;
fetch(api_url)
    .then(function(response) {
        return response.json();
    })
    .then(function(data) {
      console.log(data.products)
        appendData(data);
    })
    .catch(function(err) {
        console.log('error: ' + err);
    });
function appendData(data) {
    console.log(data.products)
    let tab = '';
    var active = '';
    for (let r of data.products) {
        if (r.handle == handle) {
            active = 'class="variante-activa" style="margin: 0 0 4px !important;"';
        } else {
            active = '';
        }
      if (r.images[1]) {
         tab += `<li ${active}>
            <div class="image var" style="padding: 4px !important">
              <a href="https://cat-mx.myshopify.com/products/${r.handle}" title="${r.title}">
                <img src="${r.image.src}" class="color_relacionado" width="75px" height="75px"/>
                <span></span>
              </a>
            </div>
          </li>`;
      }
       
    }
    current_product.innerHTML = tab;
}

// // Selecciona todos los elementos input
// let inputs = document.querySelectorAll('input[type="radio"]');

// // Función para manejar el cambio de atributos
// function handleAttributeChange(mutations) {
//   mutations.forEach((mutation) => {
//     if (mutation.attributeName === 'disabled') {
//       let element = mutation.target;
//       if (!element.disabled) {
//         console.log(`El elemento con id ${element.id} ha cambiado a disabled=false`);
//       }
//     }
//   });
// }

// // Inicia la observación
// inputs.forEach((input) => {
//   let observer = new MutationObserver(handleAttributeChange);
//   observer.observe(input, { attributes: true });
// });
